import React, { useState, forwardRef, useImperativeHandle } from 'react';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { green } from '@material-ui/core/colors';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';

import { IntegerInput, PrecoInput } from '../../Components';
import { formatMoeda } from '../../utils';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: 'white',
  },
});

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6" style={{ fontWeight: 'bold' }}>
        {children}
      </Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const useStyles = makeStyles((theme) => ({
  rootDialogo: {
    borderRadius: '25px',
  },
  btnAtions: {
    borderRadius: '25px',
    width: '150px',
  },
  btnAtionsDisabled: {
    borderRadius: '25px',
    width: '150px',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

const DEFAULT_ID = -1;

const DialogoCategoriaTransacao = forwardRef(
  ({ handleClose, handleSave, valorPrincipal, escalonadas }, ref) => {
    const [open, setOpen] = useState(false);
    const { enqueueSnackbar } = useSnackbar();
    const [valor, setValor] = useState(0);
    const [quantidade, setQuantidade] = useState(0);

    const [id, setId] = useState(DEFAULT_ID);

    const classes = useStyles({ cor: '#009FD4' });

    const handleCloseDialog = () => {
      setOpen(false);
      handleClose();
    };

    async function reiniciar() {
      setId(DEFAULT_ID);
      setValor(0);
      setQuantidade(0);
      setOpen(true);
    }

    async function handleSalvar() {
      try {
        if (id <= 0) {
          handleSave(id, valor, quantidade);
          enqueueSnackbar('Oferta de Jornal Escalonada criada com sucesso!', {
            variant: 'success',
          });
        } else {
          handleSave(id, valor, quantidade);
          enqueueSnackbar(
            'Oferta de jornal Escalonada atualizada com sucesso!',
            {
              variant: 'success',
            },
          );
        }
        handleCloseDialog();
      } catch (erros) {
        enqueueSnackbar(`${erros}`, {
          variant: 'error',
        });
        handleCloseDialog();
      }
    }

    useImperativeHandle(ref, () => ({
      handleCreate() {
        reiniciar();
        setOpen(true);
      },
      handleEdit(id, valor, quantidade) {
        setValor(valor);
        setQuantidade(quantidade);
        setId(id);
        setOpen(true);
      },
    }));

    function verifyQuantidade() {
      const index = escalonadas
        .filter((el) => el.id !== id)
        .findIndex((el) => el.quantidade === quantidade);
      return index === -1;
    }

    function getIntervaloValor() {
      const copyEscalonadas = [...escalonadas]
        .filter((el) => el.id !== id)
        .sort((a, b) => a.quantidade - b.quantidade);

      const indexMenor = copyEscalonadas.findLastIndex(
        (el) => el.quantidade < quantidade,
      );

      const indexMaior = copyEscalonadas.findIndex(
        (el) => el.quantidade > quantidade,
      );

      if (indexMenor === -1 && indexMaior === -1) {
        return {
          inicio: -1,
          fim: -1,
        };
      }

      if (indexMenor > -1) {
        if (indexMaior > -1) {
          return {
            inicio: copyEscalonadas[indexMenor].valor,
            fim: copyEscalonadas[indexMaior].valor,
          };
        }
        return {
          inicio:
            copyEscalonadas.length > 0
              ? copyEscalonadas[copyEscalonadas.length - 1].valor
              : -1,
          fim: -1,
        };
      }
      if (indexMaior > 0) {
        return {
          inicio: -1,
          fim: copyEscalonadas.length > 0 ? copyEscalonadas[0].valor : -1,
        };
      }
      return {
        inicio: -1,
        fim: -1,
      };
    }

    function validateValor(index) {
      let error = '';
      if (valor <= 0 || Number.isNaN(valor)) {
        error = 'Este campo é obrigatório';
      } else if (!index) {
        error = 'Conserte a quantidade!';
      } else if (valor >= valorPrincipal) {
        error =
          'O valor das escalonadas deve ser menor que a oferta principal!';
      } else {
        const { inicio, fim } = getIntervaloValor();

        if (fim > 0) {
          if (inicio > 0) {
            if (fim >= valor || inicio <= valor) {
              error = `Para esta quantidade o valor deve ser maior que ${formatMoeda(
                fim,
              )} e menor que ${formatMoeda(inicio)}`;
            }
          } else if (fim >= valor) {
            error = `Para esta quantidade o valor deve ser maior que ${formatMoeda(
              fim,
            )}`;
          }
        } else if (inicio > 0) {
          if (inicio <= valor) {
            error = `Para esta quantidade o valor deve ser menor que ${formatMoeda(
              inicio,
            )}`;
          }
        }
      }
      return error;
    }

    function validateQuantidade(index) {
      let error = '';
      if (quantidade <= 0 || Number.isNaN(quantidade)) {
        error = 'Este campo é obrigatório';
      } else if (!index) {
        error = 'Esta quantidade já foi cadastrada';
      }
      return error;
    }

    function getErros() {
      const errosOld = [''];
      const index = verifyQuantidade();
      errosOld[0] = validateValor(index);
      errosOld[1] = validateQuantidade(index);
      return errosOld;
    }

    const erros = getErros();

    function hasError() {
      for (let i = 0; i < erros.length; i += 1) {
        if (erros[i] !== '') return true;
      }
      return false;
    }

    const erroExistente = hasError();

    return (
      <div>
        <Dialog
          open={open}
          aria-labelledby="form-dialog-title"
          classes={{ paper: classes.rootDialogo }}
          className={classes.rootDialogo}
          fullWidth
          maxWidth="sm"
          TransitionComponent={Transition}
          keepMounted
        >
          <DialogTitle
            id="form-dialog-title"
            onClose={handleCloseDialog}
            style={{ backgroundColor: '#00796b', color: 'white' }}
          >
            {id < 0
              ? 'Nova Oferta de Jornal Escalonada'
              : 'Editar Oferta de Jornal Escalonada'}
          </DialogTitle>
          <DialogContent
            style={{
              padding: '0px 36px 20px',
              margin: '0',
            }}
          >
            <div>
              <Box flex={1} mr="0.5em">
                <Box flex={1} mr="0.5em">
                  <IntegerInput
                    name="quantidade"
                    handleEnter={() => {}}
                    label="Quantidade"
                    handleKey={() => {}}
                    value={Number.isNaN(quantidade) ? '' : String(quantidade)}
                    onChange={(value) =>
                      setQuantidade(parseInt(value.target.value, 10))
                    }
                    error={erros[1] !== ''}
                    helperText={erros[1]}
                    fullWidth
                  />
                </Box>
                <PrecoInput
                  name="valor"
                  handleEnter={() => {}}
                  label="Valor"
                  handleKey={() => {}}
                  value={Number.isNaN(valor) ? '' : String(valor)}
                  onChange={(value) => {
                    setValor(parseFloat(value.target.value));
                  }}
                  error={erros[0] !== ''}
                  helperText={erros[0]}
                  fullWidth
                  autoFocus
                />
              </Box>
            </div>
          </DialogContent>
          <DialogActions
            style={{
              padding: '0px 36px 20px',
              margin: '0',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Button
              onClick={handleCloseDialog}
              classes={{
                root: classes.btnAtions,
                disabled: classes.btnAtionsDisabled,
              }}
              variant="contained"
              color="primary"
            >
              Cancelar
            </Button>
            <div className={classes.wrapper}>
              <Button
                onClick={handleSalvar}
                classes={{
                  root: classes.btnAtions,
                  disabled: classes.btnAtionsDisabled,
                }}
                disabled={erroExistente}
                variant="contained"
                color="primary"
              >
                Salvar
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </div>
    );
  },
);

export default DialogoCategoriaTransacao;
